import { Integration_Auth_Names_Enum } from '@main/graphql/types.generated';
import z from 'zod/v4';

import * as IntegrationAuth from '../integration-auth';

export type AtlassianAuthPatConfig = (typeof AtlassianAuthPat)['_']['NamedConfig'];

export const AtlassianAuthPat = IntegrationAuth.manual({
  name: Integration_Auth_Names_Enum.PersonalAccessToken,
  configSchema: z.object({
    url: z.url(),
    email: z.email(),
  }),
  encryptedConfigSchema: z.object({
    apiToken: z.string().trim().min(1),
  }),
});
